import { useTranslation } from "react-i18next";

const languages = [
  { code: "es-ES", flag: "🇪🇸" },
  { code: "es-MX", flag: "🇲🇽" },
  { code: "es", flag: "🌎" },
  { code: "en", flag: "🇺🇸" },
  { code: "pt", flag: "🇵🇹" },
];

function LanguageSelector() {
  const { i18n } = useTranslation();

  return (
    <div className="relative">
      <div className="flex flex-wrap justify-start p-2 bg-white rounded-md">
        {languages.map((language) => (
          <button
            key={language.code}
            onClick={() => {
              i18n.changeLanguage(language.code)
              setTimeout(() => {
                window.location.reload();
              }, 100);
            }}
            className={`flex items-start space-x-2 px-3 py-2 text-sm font-medium rounded-md focus:outline-none 
              ${
                i18n.language === language.code
                  ? "bg-gray-200 shadow-md"
                  : "bg-white hover:bg-gray-100"
              }
            `}
          >
            <span>{language.flag}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default LanguageSelector;
